'use client';

import type React from 'react';
import { AppShell } from '@mantine/core';
import { useHeadroom } from '@mantine/hooks';
import { usePathname } from 'next/navigation';
import { useContext } from 'react';
import { AppLayoutContext, IdentityContext } from '../../context';
import { Header } from '../header';
import { NoFolioFooter } from './NoFolioFooter';
import { useHeaderHeight } from './useHeaderHeight';
export const APP_SHELL_STYLES = {
  header: {
    maxWidth: '100vw',
    withBorder: false,
    backgroundColor: 'white',
    opacity: '0.9'
  },
  footer: {
    borderRadius: '18px',
    margin: '20px auto'
  }
} as const;
export const PADDING_TOP = {
  onboarding: '0px',
  mobile: '60px',
  desktop: '100px'
} as const;
export function AppShellTemplate({
  children
}: React.PropsWithChildren) {
  const {
    hiddenHeader,
    mobile
  } = useContext(AppLayoutContext);
  const pinned = useHeadroom({
    fixedAt: 140
  });
  const headerHeight = useHeaderHeight(hiddenHeader);
  const pathname = usePathname();
  const {
    currentAccount
  } = useContext(IdentityContext);
  const showNoFolioFooter = currentAccount?.folioItems?.length === 0 && !pathname.includes('/onboarding') && !pathname.includes('/profile');
  const calculatePaddingTop = () => {
    if (pathname.includes('/onboarding')) return PADDING_TOP.onboarding;
    return mobile ? PADDING_TOP.mobile : PADDING_TOP.desktop;
  };
  return <AppShell padding="0px" header={{
    height: headerHeight,
    collapsed: hiddenHeader || !pinned,
    offset: false
  }} data-sentry-element="AppShell" data-sentry-component="AppShellTemplate" data-sentry-source-file="AppShellTemplate.tsx">
      <AppShell.Header maw={APP_SHELL_STYLES.header.maxWidth} withBorder={APP_SHELL_STYLES.header.withBorder} style={APP_SHELL_STYLES.header} data-sentry-element="unknown" data-sentry-source-file="AppShellTemplate.tsx">
        <Header data-sentry-element="Header" data-sentry-source-file="AppShellTemplate.tsx" />
      </AppShell.Header>
      <AppShell.Main pt={calculatePaddingTop()} data-sentry-element="unknown" data-sentry-source-file="AppShellTemplate.tsx">{children}</AppShell.Main>
      {showNoFolioFooter ? <AppShell.Footer maw={mobile ? '95%' : '80%'} withBorder={false} style={APP_SHELL_STYLES.footer}>
          <NoFolioFooter mobile={mobile} />
        </AppShell.Footer> : null}
    </AppShell>;
}